import GeozoneService from "../shared/services/geozoneService";

const REQUEST_GEOZONES = "REQUEST_GEOZONES";
const RESPONSE_GEOZONES = "RESPONSE_GEOZONES";
const REQUEST_GEOZONES_FAILURE = "REQUEST_GEOZONES_FAILURE";
const SET_SELECT_GEOZONE = "SET_SELECT_GEOZONE";

const requestGetGeozonesAction = () => {
  return {
    type: REQUEST_GEOZONES,
  };
};

const responseGetGeozonesAction = (data) => {
  return {
    type: RESPONSE_GEOZONES,
    data,
  };
};

const requestGetGeozonesfailureAction = (errors) => {
  return {
    type: REQUEST_GEOZONES_FAILURE,
    errors,
  };
};

const getGeozones = () => {
  return (dispatch) => {
    dispatch(requestGetGeozonesAction());

    GeozoneService.getGeozones()
      .then((result) => {
        dispatch(responseGetGeozonesAction(result.data));
      })
      .catch((error) => {
        dispatch(requestGetGeozonesfailureAction(error.response));
      });
  };
};

const REQUEST_CREATE_GEOZONES = "REQUEST_CREATE_GEOZONES";
const RESPONSE_CREATE_GEOZONES = "RESPONSE_CREATE_GEOZONES";
const REQUEST_CREATE_GEOZONES_FAILURE = "REQUEST_CREATE_GEOZONES_FAILURE";

const requestCreateGeozonesAction = (data) => {
  return {
    type: REQUEST_CREATE_GEOZONES,
    data,
  };
};

const responseCreateGeozonesAction = (data) => {
  return {
    type: RESPONSE_CREATE_GEOZONES,
    data,
  };
};

const requestCreateGeozonesfailureAction = (errors) => {
  return {
    type: REQUEST_CREATE_GEOZONES_FAILURE,
    errors,
  };
};

const createGeozones = (options) => {
  return (dispatch) => {
    dispatch(requestCreateGeozonesAction(options));

    GeozoneService.createGeozones(options)
      .then((result) => {
        dispatch(responseCreateGeozonesAction(result.data));
      })
      .catch((error) => {
        dispatch(requestCreateGeozonesfailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_GEOZONES = "REQUEST_DELETE_GEOZONES";
const RESPONSE_DELETE_GEOZONES = "RESPONSE_DELETE_GEOZONES";
const REQUEST_DELETE_GEOZONES_FAILURE = "REQUEST_DELETE_GEOZONES_FAILURE";

const requestDeleteGeozonesAction = () => {
  return {
    type: REQUEST_DELETE_GEOZONES,
  };
};

const responseDeleteGeozonesAction = (data) => {
  return {
    type: RESPONSE_DELETE_GEOZONES,
    data,
  };
};

const requestDeleteGeozonesfailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_GEOZONES_FAILURE,
    errors,
  };
};

const deleteGeozone = (id) => {
  return (dispatch) => {
    dispatch(requestDeleteGeozonesAction());

    return GeozoneService.delete(id)
      .then(() => {
        return dispatch(responseDeleteGeozonesAction(id));
      })
      .catch((error) => {
        dispatch(requestDeleteGeozonesfailureAction(error.response));
      });
  };
};

const REQUEST_UPDATE_GEOZONES = "REQUEST_UPDATE_GEOZONES";
const RESPONSE_UPDATE_GEOZONES = "RESPONSE_UPDATE_GEOZONES";
const REQUEST_UPDATE_GEOZONES_FAILURE = "REQUEST_UPDATE_GEOZONES_FAILURE";

const requestUpdateGeozonesAction = () => {
  return {
    type: REQUEST_UPDATE_GEOZONES,
  };
};

const responseUpdateGeozonesAction = (data) => {
  return {
    type: RESPONSE_UPDATE_GEOZONES,
    data,
  };
};

const requestUpdateGeozonesfailureAction = (errors) => {
  return {
    type: REQUEST_UPDATE_GEOZONES_FAILURE,
    errors,
  };
};

const updateGeozone = (id, options, isGeometryChanged = false) => {
  return (dispatch) => {
    dispatch(requestUpdateGeozonesAction());

    return GeozoneService.update(id, options, isGeometryChanged)
      .then(() => {
        return dispatch(responseUpdateGeozonesAction(options));
      })
      .catch((error) => {
        dispatch(requestUpdateGeozonesfailureAction(error.response));
      });
  };
};

const setSelectGeozoneAction = (data) => {
  return {
    type: SET_SELECT_GEOZONE,
    selectGeozone: data,
  };
};

const selectGeozone = (geozone) => {
  return (dispatch) => {
    dispatch(setSelectGeozoneAction(geozone));
  };
};

const REQUEST_ADD_UNIT_TO_GEOZONE = "REQUEST_ADD_UNIT_TO_GEOZONE";
const RESPONSE_ADD_UNIT_TO_GEOZONE = "RESPONSE_ADD_UNIT_TO_GEOZONE";
const REQUEST_ADD_UNIT_TO_GEOZONE_FAILURE = "REQUEST_ADD_UNIT_TO_GEOZONE_FAILURE";

const requestAddUnitToGeozoneAction = () => {
  return {
    type: REQUEST_ADD_UNIT_TO_GEOZONE,
  };
};

const responseAddUnitToGeozoneAction = (data) => {
  return {
    type: RESPONSE_ADD_UNIT_TO_GEOZONE,
    data,
  };
};

const rrequestAddUnitToGeozoneActionFailureAction = (errors) => {
  return {
    type: REQUEST_ADD_UNIT_TO_GEOZONE_FAILURE,
    errors,
  };
};

const addUnitToGeozone = (id, car) => {
  return (dispatch) => {
    dispatch(requestAddUnitToGeozoneAction());

    return GeozoneService.addUnit(id, car.id)
      .then(() => {
        return dispatch(responseAddUnitToGeozoneAction(car));
      })
      .catch((error) => {
        dispatch(rrequestAddUnitToGeozoneActionFailureAction(error.response));
      });
  };
};

const REQUEST_DELETE_UNIT_TO_GEOZONE = "REQUEST_DELETE_UNIT_TO_GEOZONE";
const RESPONSE_DELETE_UNIT_TO_GEOZONE = "RESPONSE_DELETE_UNIT_TO_GEOZONE";
const REQUEST_DELETE_UNIT_TO_GEOZONE_FAILURE = "REQUEST_DELETE_UNIT_TO_GEOZONE_FAILURE";

const requestDeleteUnitToGeozoneAction = () => {
  return {
    type: REQUEST_DELETE_UNIT_TO_GEOZONE,
  };
};

const responseDeleteUnitToGeozoneAction = (data) => {
  return {
    type: RESPONSE_DELETE_UNIT_TO_GEOZONE,
    data,
  };
};

const rrequestDeleteUnitToGeozoneActionFailureAction = (errors) => {
  return {
    type: REQUEST_DELETE_UNIT_TO_GEOZONE_FAILURE,
    errors,
  };
};

const deleteUnitToGeozone = (id, car) => {
  return (dispatch) => {
    dispatch(requestDeleteUnitToGeozoneAction());

    return GeozoneService.deleteUnit(id, car.id)
      .then(() => {
        return dispatch(responseDeleteUnitToGeozoneAction(car));
      })
      .catch((error) => {
        dispatch(rrequestDeleteUnitToGeozoneActionFailureAction(error.response));
      });
  };
};

export {
  getGeozones,
  REQUEST_GEOZONES,
  RESPONSE_GEOZONES,
  REQUEST_GEOZONES_FAILURE,
  createGeozones,
  REQUEST_CREATE_GEOZONES,
  RESPONSE_CREATE_GEOZONES,
  REQUEST_CREATE_GEOZONES_FAILURE,
  deleteGeozone,
  REQUEST_DELETE_GEOZONES,
  RESPONSE_DELETE_GEOZONES,
  REQUEST_DELETE_GEOZONES_FAILURE,
  updateGeozone,
  REQUEST_UPDATE_GEOZONES,
  RESPONSE_UPDATE_GEOZONES,
  REQUEST_UPDATE_GEOZONES_FAILURE,
  selectGeozone,
  SET_SELECT_GEOZONE,
  addUnitToGeozone,
  REQUEST_ADD_UNIT_TO_GEOZONE,
  RESPONSE_ADD_UNIT_TO_GEOZONE,
  REQUEST_ADD_UNIT_TO_GEOZONE_FAILURE,
  deleteUnitToGeozone,
  REQUEST_DELETE_UNIT_TO_GEOZONE,
  RESPONSE_DELETE_UNIT_TO_GEOZONE,
  REQUEST_DELETE_UNIT_TO_GEOZONE_FAILURE,
};
